module.exports = __webpack_public_path__ + "static/assets/87f84c8c2069ee907a57bf14c5819482.svg";